import React, {Component} from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

class HeatMapColLabels extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const sizeDifferent = nextProps.cellSize !== this.props.cellSize;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimXDiff = nextProps.dimX !== this.props.dimX;
    const dimYDiff = nextProps.dimY !== this.props.dimY;
    const sortDiff = nextProps.sortField !== this.props.sortField;
    const hoverDiff = nextProps.hoverIndex !== this.props.hoverIndex;

    return sizeDifferent || dataDifferent || dimXDiff || dimYDiff || sortDiff || hoverDiff;
  }

  getClassName(d, i) {
    let cl = "colLabel mono c" + i;

    if (this.props.sortField === d.field) {
      cl += ' sort-col';
    }

    if (this.props.hoverIndex === i) {
      cl += ' highlight';
    }

    if (this.props.dimX === d.field) {
      cl += ' x-col';
    }
    else if (this.props.dimY === d.field) {
      cl += ' y-col';
    }

    return cl
  }

  getText(d, i) {
    const text = _.truncate(d.label, {length: 60});
    if (this.props.sortField === d.field) {
      return '◄ ' + text
    }
    return text
  }

  render() {
    const data = this.props.data || [];
    const cellSize = this.props.cellSize;
    const height = this.props.height * 1.2;

    const getHandlers = (d, i) => {
      const onClick = this.props.onClick;
      const onHover = this.props.onHover;
      const handlers = {};

      if (onClick) {
        handlers.onClick = () => onClick(d, i);
      }

      if (onHover) {
        handlers.onMouseEnter = () => onHover(i);
        handlers.onMouseLeave = () => onHover(-1);
      }

      return handlers;
    };

    return (
      <g>
        {_.map(data, (d, i) => {
          return (
            <g key={i}
               className="colLabelGroup"
               height={cellSize}
               width={height}
               transform={`translate(${i * cellSize - cellSize / 1.8},0) rotate (-50)`}
               {...getHandlers(d, i)}>
              <rect
                className="background"
                height={cellSize}
                width={height}
              ></rect>
              <text
                x={20}
                y={cellSize / 2}
                alignmentBaseline="middle"
                className={this.getClassName(d, i)}>
                {this.getText(d)}
              </text>
            </g>
          )
        })}
      </g>
    )
  }
}

HeatMapColLabels.propTypes = {
  cellSize: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  data: PropTypes.array,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  sortField: PropTypes.string,
  hoverIndex: PropTypes.number
};

export default HeatMapColLabels


// WEBPACK FOOTER //
// ./src/charts/HeatMap/HeatMapColLabels.js